import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { skills } from "../../Data/Constants";
import { Tilt } from "react-tilt";
import Aos from "aos";
import "aos/dist/aos.css";
import Css_image from "../../Images/Css.png";
import Html_image from "../../Images/Html.png";
import React_image from "../../Images/React.png";
import Js_image from "../../Images/Js.png";
import Node_js_image from "../../Images/Nodejs.png";
import Python_image from "../../Images/Python.png";
import MySQL_image from "../../Images/MySQL.png";
import Flask_image from "../../Images/Flask.png";
import GitHub_image from "../../Images/Github.png";
import git_image from "../../Images/git.png";
import Docker_image from "../../Images/Docker.png";
import VS_image from "../../Images/VS.png";
import Linux_image from "../../Images/Linux.png";
import Java_image from "../../Images/Java.png";
import C_Image from "../../Images/C.png";
import C_sharp_Image from "../../Images/C_sharp.png";
import Express_image from "../../Images/Express.png";
import Rest_API_image from "../../Images/RestAPI.png";
import Cpp_image from "../../Images/Cpp.png";
import Security_image from "../../Images/Security.svg";
import Network_image from "../../Images/Network.svg";
import Cloud_image from "../../Images/Cloud.svg";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-contnet: center;
  position: rlative;
  z-index: 1;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
  animation: test linear;
  animation-timeline: view();

  @keyframes test {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const SkillsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(360px, 1fr));
  align-items: stretch;
  margin-top: 20px;
  gap: 28px 38px;
  justify-content: center;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const Skill = styled.div`
  width: 100%;
  height: 100%;
  min-height: 210px;
  background-color: rgba(17, 25, 40, 0.83);
  border: 1px solid rgba(255, 255, 255, 0.125);
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  border-radius: 16px;
  padding: 18px 28px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (max-width: 768px) {
    min-height: 190px;
    padding: 12px 20px;
  }

  @media (max-width: 500px) {
    max-width: 330px;
    padding: 10px 18px;
    margin: 0 auto;
  }
`;

const SkillTitle = styled.div`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
`;

const SkillList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  flex: 1;
  align-content: center;
`;

const SkillItem = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary};
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 148px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02);

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 12px;
    min-width: 120px;
  }
  @media (max-width: 500px) {
    font-size: 14px;
    padding: 6px 12px;
    min-width: 110px;
  }
`;

const SkillImage = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.25));
`;

const Skills = () => {
  const imageDictionary = useMemo(() => {
    return {
      "React Js": React_image,
      HTML: Html_image,
      CSS: Css_image,
      JavaScript: Js_image,
      "Node Js": Node_js_image,
      Flask: Flask_image,
      MySQL: MySQL_image,
      Python: Python_image,
      GitHub: GitHub_image,
      Git: git_image,
      Docker: Docker_image,
      "VS Code": VS_image,
      Linux: Linux_image,
      Networking: Network_image,
      Cybersecurity: Security_image,
      RTOS: Cloud_image,
      Java: Java_image,
      C: C_Image,
      "C#": C_sharp_Image,
      "C++": Cpp_image,
      Express: Express_image,
      "Rest API": Rest_API_image,
      Cursor: VS_image,
      "Claude Code": VS_image,
      "GitHub Copilot": GitHub_image,
      LLMs: Python_image,
      "Prompt Engineering": Js_image,
      "AI Automation": React_image,
    };
  }, []);

  useEffect(() => {
    Aos.init();
  });

  function getimage(item) {
    return imageDictionary[item.name];
  }

  return (
    <Container id="Skills">
      <Wrapper>
        <Title data-aos="zoom-in" data-aos-once="true">
          Skills
        </Title>
        <Desc
          style={{
            marginBottom: "40px",
          }}
          data-aos="zoom-in"
          data-aos-once="true"
        >
          Here are some of my skills on which I have been working on for the
          past 3 years.
        </Desc>

        <SkillsContainer>
          {skills.map((skill, index) => (
            <Tilt
              options={{
                max: 45,
                scale: 1,
                speed: 450,
              }}
              key={index}
            >
              {index % 2 === 0 && (
                <Skill key={index} data-aos="flip-right" data-aos-once="true">
                  <SkillTitle>{skill.title}</SkillTitle>
                  <SkillList>
                    {skill.skills.map((item, index_x) => (
                      <SkillItem
                        key={index_x}
                        data-aos="fade-down"
                        data-aos-once="true"
                      >
                        <SkillImage src={getimage(item)} />
                        {item.name}
                      </SkillItem>
                    ))}
                  </SkillList>
                </Skill>
              )}
              {index % 2 !== 0 && (
                <Skill key={index} data-aos="flip-left" data-aos-once="true">
                  <SkillTitle>{skill.title}</SkillTitle>
                  <SkillList>
                    {skill.skills.map((item, index_x) => (
                      <SkillItem
                        key={index_x}
                        data-aos="fade-down"
                        data-aos-once="true"
                      >
                        <SkillImage src={getimage(item)} />
                        {item.name}
                      </SkillItem>
                    ))}
                  </SkillList>
                </Skill>
              )}
            </Tilt>
          ))}
        </SkillsContainer>
      </Wrapper>
    </Container>
  );
};

export default Skills;
